import MapOutlinedIcon from "@material-ui/icons/MapOutlined";
import { TrailerLocationsView } from "./TrailerLocationsView";

export default {
  icon: MapOutlinedIcon,
  list: TrailerLocationsView,
};
